import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import Notification from '../../../../components/Notification/Notification';
import { basicReferralGradeRewardLogListRequest } from '../../../../redux/actions/app/basicActions';
import { getUserPageAuth } from '../../../../utils/page-auth';
import PaginationOptions, { Page } from '../../../../api/ui/paginationOptions';
import BOTable from '../../../../components/Tables/BOTable';
import Visible from '../../../../components/Custom/Visible';
import PaginationComponent from '../../../../components/Custom/PaginationComponent';
import {
  DEFAULT_END_AT,
  DEFAULT_START_AT,
} from '../../../LogManagement/constants';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import useSchemaBasicReferralRewardLog from '../../../../schema/table-schema/useSchemaBasicReferralRewardLog';
import {
    SearchBtnContainer,
    SearchContainer, SearchContent,
    SearchDateRange,
    SearchLabel,
    SearchRow
} from "../../../../components/Search/searchSection";
import {UIConstants} from "../../../../constants/UIConstants";

function BasicReferralRewardLog() {
  // -- component const --//
  const title = 'Basic Referral Reward Log';
  const OPTION_KEY = Page.APP_BASIC_REFERRAL;

  const { schema } = useSchemaBasicReferralRewardLog();

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 페이지 옵션
  const [pageOption, setPageOption] = useState();
  const [page, setPage] = useState(1);
  const [pageLength, setPageLength] = useState(25);

  const [isLoading, setIsLoading] = useState(false);

  const [tBody, setTbody] = useState();
  const [totalCount, setTotalCount] = useState(0);
  // 검색
  const [accountNo, setAccountNo] = useState(0);
  const [contentNo, setContentNo] = useState(0);
  const [startAt, setStartAt] = useState(DEFAULT_START_AT);
  const [endAt, setEndAt] = useState(DEFAULT_END_AT);
  const [isReset, setIsReset] = useState(false);

  // -- func & handler --//
  const fetchList = () => {
    console.log('fetchList');
    setIsLoading(true);
    console.log('page: ', page);
    dispatch(
      basicReferralGradeRewardLogListRequest({
        page: page,
        pageLength: Number(pageLength),
        beginDate: startAt,
        endDate: endAt,
        accountNo: accountNo,
        contentNo: contentNo,
        callback: (data) => {
          console.log('요청 결과: ', data);
          setTotalCount(data?.totalCount);
          // setTbody(data?.list);

          // 인덱스를 추가하여 새로운 배열을 생성(중복 키 방지)
          const listWithIndex = data?.list.map((item, index) => ({
            index: index + 1, // 인덱스는 1부터 시작(번호 표기시 편의를 위해)
            ...item,
          }));

          setTbody(listWithIndex);

          setIsLoading(false);
        },
        error: (e) => {
          console.log(e);
          setNotificationMessage(e.toString());
          setShowNotification(true);

          setIsLoading(false);
        },
      }),
    );
  };

  const handlePageChange = (_, value) => {
    setPage(Number(value));
  };

  const handlePageLengthChange = (value) => {
    setPageLength(value);
    setPage(1);
  };
  const handleSearchClick = () => {
    if (page === 1) {
      fetchList();
      return;
    }

    setPage(1);
  };

  function handleResetClick() {
    setAccountNo(0);
    setContentNo(0);
    setIsReset(true);
  }

  useEffect(() => {
    if (!accountNo && !contentNo) {
      fetchList();
    }
  }, [accountNo, contentNo]);

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    PaginationOptions.getInstance().then((instance) => {
      const option = instance?.getData(OPTION_KEY);
      setPageOption(option);

      if (option.list_count_elements?.length > 0) {
        setPageLength(Number(25));
      }
    });
  }, [OPTION_KEY]);

  useEffect(() => {
    fetchList();
  }, [page, pageLength]);

    useEffect(() => {
        if(isReset){
            setIsReset(false);
            fetchList()
        }
    }, [isReset]);

  // -- render --//
  return (
    <div className="page">
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <section className="topSection">
        <div className="leftSection">
          <p className="titleText">{title}</p>
        </div>
          <div className="rightSection">
              <button
                  className={"outlineBtn"}
                  onClick={() => {
                      fetchList();
                  }}
              >
                  List 갱신
              </button>
          </div>
      </section>

        <div className="spaceDiv10" />

        <section>
            <SearchContainer>
                <SearchRow>
                    <SearchLabel text={UIConstants.Date}/>
                    <SearchDateRange
                        startAt={startAt}
                        endAt={endAt}
                        setStartAt={setStartAt}
                        setEndAt={setEndAt}
                    />
                </SearchRow>

                <SearchRow>
                    <SearchLabel text={UIConstants.UserId}/>
                    <SearchContent>
                        <input
                            className=""
                            value={accountNo === 0 ? '' : accountNo}
                            placeholder="유저 ID"
                            onChange={(e) => {
                                setAccountNo(Number(e.target.value));
                            }}
                        />
                    </SearchContent>

                    <SearchLabel text={"콘텐츠 번호"}/>
                    <SearchContent>
                        <input
                            className=""
                            value={contentNo === 0 ? '' : contentNo}
                            placeholder="콘텐츠 번호"
                            onChange={(e) => {
                                setContentNo(Number(e.target.value));
                            }}
                        />
                    </SearchContent>
                </SearchRow>
            </SearchContainer>


            <SearchBtnContainer
                handleSearchClick={handleSearchClick}
                handleResetClick={handleResetClick}
            />
        </section>

        <Visible Visible visible={pageOption?.top_paging}>
            <PaginationComponent
                disable={false}
                option={pageOption}
                page={page}
                pageLength={pageLength}
                totalCount={totalCount}
                onChange={handlePageChange}
                onSelect={handlePageLengthChange}
            />
        </Visible>

      <div className="spaceDiv10" />

      <BOTable
        className={'basicReferralPointLogTable'}
        schema={schema}
        rows={tBody}
        loading={isLoading}
      />

      <div className="spaceDiv10" />

      <Visible Visible visible={pageOption?.bottom_paging}>
        <PaginationComponent
          disable={false}
          option={pageOption}
          page={page}
          pageLength={pageLength}
          totalCount={totalCount}
          onChange={handlePageChange}
          onSelect={handlePageLengthChange}
        />
      </Visible>

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default BasicReferralRewardLog;
